'use strict';

var angular = require('angular');
var lodash = require('lodash');

var app = angular.module('app');

/**
 *
 * @description Bootstrap a like modal - acts as a container that invokes animation for general
 *   purpose modals
 *
 * @param $document - Angular $document service
 * @param $rootScope - Angular $rootScope service
 * @param $compile - Angular $compile service
 * @param $controller - Angular $controller service
 * @param $animate - Angular $animate service
 * @constructor
 */
function Modal($document, $rootScope, $compile, $controller, $animate, $q) {

    document.addEventListener('keyup', function (e) {
        if (e.keyCode === 27) {
            $rootScope.$broadcast('Modal.escapeKey');
            $rootScope.$apply();
        }
    });

    this.showModal = function (options) {
        // Create new isolated scope
        var scope = $rootScope.$new(true);
        var closeDeferred = $q.defer();

        var mode = "fullscreen";
        if (options && options.mode)
            mode = options.mode;

        // Create DOM Nodes
        var elContainer = angular.element('<div class="modal"></div>');
        var elTemplate = angular.element(options.template());

        function close() {
            closeDeferred.resolve();
        }

        function closeModal() {
            // if (mode == "fullscreen")
            //     BlurBackground.remove('modal');

            return $animate
                .leave(elTemplate)
                .then(function () {
                    elContainer.remove();
                    scope.$destroy();
                });
        }

        closeDeferred
            .promise
            .then(closeModal, closeModal);

        // Serve as dependency injection inputs for a controller
        var inputs = lodash.assign({
            '$scope': scope,
            '$element': elTemplate,
            closeDeferred: closeDeferred
        }, options.inputs);

        // Create instance of a controller
        $controller(options.controller, inputs);

        // Compile - angular's way of finding directives through traversing the input DOM element and its descendants
        $compile(elTemplate)(scope);

        // Inject elContainer at the bottom of body
        if (mode == "fullscreen")
            $document.find('body').prepend(elContainer);
        else if (mode == "top-slider")
            $document.find('header.site-header').prepend(elContainer);

        // // Run body blur effect
        // if (mode == "fullscreen")
        //     BlurBackground.add('modal');

        // Prevent closing of the modal window on click
        if (mode == "fullscreen") {

            elTemplate.on('click', function (e) {
                e.stopPropagation();
            });

            // Click on background element
            elContainer.on('click', function (e) {
                e.stopPropagation();

                close();
            });

            scope.$on('Modal.escapeKey', close);
        }

        return {
            animationPromise: $animate.enter(elTemplate, elContainer),
            closePromise: closeDeferred.promise
        };
    };
}
app.service('Modal', Modal);
